// Custom Styling
import './assets/scss/main.scss';

// Bootstrap, Font Awesome
import 'bootstrap/dist/js/bootstrap.min';
import '@fortawesome/fontawesome-free/css/all.min.css';

// Vue, Vuex, Vue Router
import Vue from 'vue';
import vSelect from 'vue-select';
import App from './App.vue';
import router from './router';
import store from './store';

// i18n
import i18n from './i18n';

// V-Select
import 'vue-select/dist/vue-select.css';

// Progress bar
import VueProgressBar from 'vue-progressbar';

// Snotify
import Snotify, { SnotifyPosition } from 'vue-snotify';

// Vue Loading
import 'vue-loading-overlay/dist/vue-loading.css';

// Vue Sidebar
import VueSidebarMenu from 'vue-sidebar-menu';

// Swatches
import 'vue-swatches/dist/vue-swatches.min.css';

// Mixins
import ApiErrorCodeMixin from './mixins/ApiErrorCodeMixin';

// VideoJS
import 'video.js/dist/video-js.min.css';

// Clipboard
import VueClipboard from 'vue-clipboard2';

// Axios
window.axios = require('axios');

window.axios.defaults.headers.common['Content-Type'] = 'application/json';
Vue.component('v-select', vSelect);
Vue.use(VueProgressBar, {
  color: '#22667c',
  failedColor: '#cd5c5c',
  thickness: '7px',
});
const options = {
  toast: {
    position: SnotifyPosition.rightBottom,
    timeout: 4000,
  },
};
Vue.use(Snotify, options);

// Vue Moment
Vue.use(require('vue-moment'));

Vue.use(VueSidebarMenu);

Vue.config.productionTip = false;
Vue.use(VueClipboard);

const vue = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

// export Vue so the instance can be used outside of Vue files
export { vue };
